export enum Durations {
  Short = 0.15,
  Long = 0.25,
}
